import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75f4bc17"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
import { onUnmounted, ref } from 'vue';
import { message } from 'ant-design-vue';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CopyButton',
  props: {
    text: null,
    label: null
  },
  setup(__props) {
    const props = __props;
    /**
     * 通用复制按钮（行内 hover 显示）
     * - 父容器加 hover 触发显示（通过 `.copy-btn { opacity: 0 }` + 父级 hover 状态控制）
     * - 点击复制 props.text 到剪贴板；成功后短暂切换为「✓ 已复制」
     * - 优先用 navigator.clipboard，降级到 document.execCommand
     *
     * 使用方式：
     *   <CopyButton :text="value" :label="'描述用于 toast'" />
     *   外层用 `.param-row:hover .copy-btn { opacity: 1 }` 控制可见性
     */
    const copied = ref(false);
    let resetTimer = null;
    let isUnmounted = false;
    onUnmounted(() => {
      isUnmounted = true;
      if (resetTimer) clearTimeout(resetTimer);
    });
    /**
     * 复制到剪贴板
     * 优先用 navigator.clipboard（HTTPS / localhost），不支持时降级 execCommand
     */
    const copyToClipboard = async text => {
      var _navigator$clipboard;
      if (typeof navigator !== 'undefined' && (_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch {
          // 降级到 execCommand
        }
      }
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        return ok;
      } catch {
        return false;
      }
    };
    const handleCopy = async () => {
      const ok = await copyToClipboard(props.text);
      if (isUnmounted) return;
      if (ok) {
        copied.value = true;
        message.success(props.label ? `${props.label} 复制成功` : '复制成功');
        if (resetTimer) clearTimeout(resetTimer);
        resetTimer = setTimeout(() => {
          if (!isUnmounted) copied.value = false;
        }, 1500);
      } else {
        message.error('复制失败，请手动选中复制');
      }
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      return _openBlock(), _createBlock(_component_a_tooltip, {
        title: copied.value ? '已复制' : '复制',
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          class: _normalizeClass(["copy-btn", {
            'copy-btn--copied': copied.value
          }]),
          onClick: _withModifiers(handleCopy, ["stop"])
        }, [copied.value ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(CopyOutlined), {
          key: 1
        }))], 10, _hoisted_1)]),
        _: 1
      }, 8, ["title"]);
    };
  }
});